var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditWhiteOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.22925 11.3327C1.26258 11.3327 1.29591 11.3293 1.32924 11.3243L4.1323 10.8327C4.16563 10.826 4.19729 10.811 4.22062 10.786L11.2849 3.72102C11.3004 3.7056 11.3126 3.68728 11.321 3.66712C11.3294 3.64696 11.3337 3.62534 11.3337 3.60352C11.3337 3.58169 11.3294 3.56007 11.321 3.53991C11.3126 3.51975 11.3004 3.50143 11.2849 3.48602L8.5152 0.714349C8.48353 0.682682 8.44187 0.666016 8.39688 0.666016C8.35188 0.666016 8.31022 0.682682 8.27856 0.714349L1.21426 7.77935C1.18926 7.80435 1.17426 7.83435 1.16759 7.86768L0.675976 10.671C0.659764 10.7603 0.665556 10.8522 0.692852 10.9387C0.720148 11.0253 0.768124 11.1039 0.832627 11.1677C0.942616 11.2743 1.08094 11.3327 1.22925 11.3327ZM2.35248 8.42601L8.39688 2.38268L9.61842 3.60435L3.57402 9.64768L2.0925 9.90935L2.35248 8.42601Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhiteOutlined);
export default __webpack_public_path__ + "static/media/editWhiteOutlined.6a5c652f88d37344021d2eb351b36851.svg";
export { ForwardRef as ReactComponent };